import { render, staticRenderFns } from "./StartupManagement.vue?vue&type=template&id=0d1ed266&scoped=true"
import script from "./StartupManagement.vue?vue&type=script&lang=js"
export * from "./StartupManagement.vue?vue&type=script&lang=js"
import style0 from "./StartupManagement.vue?vue&type=style&index=0&id=0d1ed266&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1ed266",
  null
  
)

export default component.exports